import type { FC } from 'react';
import React from 'react';

import { FeedFollow } from './FeedFollow.tsx';
import { useFeedFollow } from './useFeedFollow.ts';

type FeedFollowActionProps = {
	userId?: string | null;
};

/**
 * Live "Follow / Unfollow" label for the migrated `UserProfileCardWithTrigger`.
 *
 * This component instead subscribes to `useFeedFollow` directly, so it always
 * re-renders with the current `followed` value once the mutation's `refetchQueries`
 * updates `followedUsers` — matching the legacy `ProfileCardTrigger` behavior.
 */
export const FeedFollowAction: FC<FeedFollowActionProps> = ({ userId }) => {
	const { followedUsers } = useFeedFollow();
	const followed = !!(userId && followedUsers?.includes(userId));

	return <FeedFollow followed={followed} />;
};
